import { CreatePointSettingType } from '@/types';
import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import Header from '../../Header';
import Grid from '@mui/material/Unstable_Grid2';
import { ChangeEvent } from 'react';

const statusList = [
  { value: 0, label: '대기' },
  { value: 1, label: '진행중' },
  { value: 2, label: '종료' },
];
export default function PointSettingForm({
  settings,
  setSettings,
}: {
  settings: CreatePointSettingType;
  setSettings: (value: any) => void;
}) {
  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    // if (['minUsdt', 'maxUsdt', 'goalUsdt'].includes(name)) {
    //   const isCheck = isCheckInteger(value);
    //   if (!isCheck) {
    //     toast.error('소수점을 사용할 수 없습니다.');
    //     return;
    //   }
    // }
    setSettings((prev: CreatePointSettingType) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    if (!name || !value) {
      return;
    }
    setSettings((prev: CreatePointSettingType) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <>
      <Card>
        <Header title="123" />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Season</InputLabel>
                <OutlinedInput
                  type="number"
                  value={settings.season === 0 ? '' : settings.season}
                  label="season"
                  name="season"
                  onChange={handleChangeValue}
                />
              </FormControl>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Code</InputLabel>
                <OutlinedInput value={settings.code} label="code" name="code" onChange={handleChangeValue} />
                <FormHelperText>※ 포인트 게임이 동일할 때 같은 코드</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Box mb={3} />

          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>1회 획득 수량</InputLabel>
                <OutlinedInput
                  type="number"
                  value={settings.amount}
                  label="amount"
                  name="amount"
                  onChange={handleChangeValue}
                />
                <FormHelperText>※ 포인트 1회 획득 수량</FormHelperText>
              </FormControl>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>총 참여 횟수</InputLabel>
                <OutlinedInput
                  value={settings.totUserJoin === 0 ? '' : settings.totUserJoin}
                  label="totUserJoin"
                  name="totUserJoin"
                  onChange={handleChangeValue}
                />
                <FormHelperText>※ 참여자 전체가 정해진 총 횟수 내에서만 참여 가능, (0이면 무제한)</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Box mb={3} />

          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>추천인 최대 가능 횟수</InputLabel>
                <OutlinedInput
                  type="number"
                  value={settings.referralReceivedMax === 0 ? '' : settings.referralReceivedMax}
                  label="referralReceivedMax"
                  name="referralReceivedMax"
                  onChange={handleChangeValue}
                />
              </FormControl>
              <FormHelperText>※ 0이면 무제한</FormHelperText>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>추천인 포인트</InputLabel>
                <OutlinedInput
                  value={settings.referralReceived}
                  label="referralReceived"
                  name="referralReceived"
                  onChange={handleChangeValue}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Box mb={3} />

          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>상태</InputLabel>
                <Select
                  label="status"
                  name="status"
                  variant="outlined"
                  value={settings.status.toString()}
                  onChange={handleChangeSelect}
                >
                  {statusList &&
                    statusList.map((option: any) => (
                      <MenuItem key={option.label} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>피추천인 가입 포인트</InputLabel>
                <OutlinedInput
                  value={settings.referralJoin}
                  label="referralJoin"
                  name="referralJoin"
                  onChange={handleChangeValue}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Box mb={3} />

          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>일 참여 횟수 설정 </InputLabel>
                <OutlinedInput
                  type="number"
                  value={settings.dayParticipationCnt === 0 ? '' : settings.dayParticipationCnt}
                  label="dayParticipationCnt"
                  name="dayParticipationCnt"
                  onChange={handleChangeValue}
                />
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
